import React from 'react';
import { Form, Grid } from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import ChemicalProductDetailsContainer from '../../ChemicalProduct/ChemicalProductDetails/ChemicalProductDetailsContainer';
import { ChemicalProduct } from '../../../routes';
import { compose } from 'redux';
import { withRouter } from 'react-router';

class ChemicalProductDetailsForm extends React.PureComponent {
  constructor(props) {
    super(props);
    this.isChemProdRouter = this.isChemicalProductsRouter();
  }

  isChemicalProductsRouter = () => {
    const path = this.props.location && this.props.location.pathname.split(/(?=\/)/g);
    return path && path[0] == ChemicalProduct.baseName;
  };

  getCenteredGridComponent = (component, className) => {
    return (
      <Grid stackable columns={1} className={className}>
        {this.isChemProdRouter && <Grid.Column tablet={2} computer={4} only="tablet computer" />}
        <Grid.Column
          tablet={this.isChemProdRouter ? 12 : 16}
          computer={this.isChemProdRouter ? 8 : 16}
          className="detailsGridCol"
        >
          {component}
        </Grid.Column>
      </Grid>
    );
  };

  render() {
    const { buttons } = this.props;
    const chemicalProductDetailsContainerComponent = (
      <ChemicalProductDetailsContainer {...this.props} isChemProdRouter={true} />
    );

    return (
      <Form id="chemicalProductDetailsForm" className="smallScreenReduceLeftRightPadding">
        {this.getCenteredGridComponent(buttons, 'smallScreenReduceBottomPadding')}
        {this.getCenteredGridComponent(chemicalProductDetailsContainerComponent)}
        {this.getCenteredGridComponent(buttons, 'smallScreenReduceTopPadding')}
      </Form>
    );
  }
}

export default compose(withTranslation(), withRouter)(ChemicalProductDetailsForm);
